export const isDevEnvironment = (): boolean => {
  return ["local", "development"].includes(import.meta.env.VITE_APP_ENVIRONMENT);
};

export const formatPoints = (points: number | null): string => {
  if (points === null || isNaN(points)) return "0";
  return Number(points).toLocaleString();
};

export const formatLastMonthPoints = (points: number): string => {
  const formatted = formatPoints(points);
  return points > 0 ? `+ ${formatted}` : formatted;
};

const rankMap: Record<string, string> = {
  white: "Foundational",
  yellow: "Intermediate",
  green: "Advanced",
  brown: "Professional",
  black: "Expert",
};

export const mapRankToLevel = (rank: string): string => {
  return rankMap[rank] || rank;
};

export const getDeltaComparisonText = (delta: number): string => {
  if (delta === 0) return "No change from last month";
  if (delta > 0) return `${delta} more than last month`;
  return `${Math.abs(delta)} less than last month`;
};
